var map = {
	"./cyberdefence24/index.scss": "0352",
	"./energetyka24/index.scss": "f1ff",
	"./infosecurity24/index.scss": "c8e9",
	"./kadecirp-zone/index.scss": "0199",
	"./premium-zone/index.scss": "b707",
	"./space24/index.scss": "1257"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "36ba";